import { AnyAction } from 'redux';

import { PaginatedItems } from 'shared/interface/PaginatedItems';
import { ImediateActionOrder, OrderItem } from 'shared/interface/OrderRow';

import { OrdersActions } from './ordersActions';

interface InitialState {
  immediateActionOrders: PaginatedItems<ImediateActionOrder> | null;
  orderTable: PaginatedItems<OrderItem> | null;
  latestRequestSequence: number;
}

const initialState: InitialState = {
  immediateActionOrders: null,
  orderTable: null,
  latestRequestSequence: 0,
};

export const ordersReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case OrdersActions.SET_BOARD_ORDERS:
      // Only update if this response matches the latest request sequence
      // If requestSequence is undefined (legacy calls), always allow update
      if (
        action.payload.requestSequence !== undefined &&
        action.payload.requestSequence < state.latestRequestSequence
      ) {
        return state; // Ignore stale response
      }

      return {
        ...state,
        orderTable: {
          ...action.payload.orders,
          items:
            state.orderTable && action.payload.append
              ? [...state.orderTable?.items, ...action.payload.orders.items]
              : [...action.payload.orders.items],
        } as PaginatedItems<OrderItem>,
        // Only update sequence if provided, otherwise keep current
        latestRequestSequence:
          action.payload.requestSequence !== undefined
            ? action.payload.requestSequence
            : state.latestRequestSequence,
      };
    case OrdersActions.SET_IMMEDIATE_ACTIONS_FOR_ORDERS:
      return {
        ...state,
        immediateActionOrders:
          action.payload as PaginatedItems<ImediateActionOrder>,
      };

    case OrdersActions.RESET_ORDERS:
      return {
        ...state,
        orderTable: null,
      };

    case 'UPDATE_LATEST_REQUEST_SEQUENCE':
      return {
        ...state,
        latestRequestSequence: action.payload,
      };

    case OrdersActions.SET_ORDER_CANCEL_REQUEST:
      return {
        ...state,
        orderTable: {
          ...state.orderTable,
          items: (state.orderTable?.items ?? []).map((item) =>
            item.id === action.payload
              ? { ...item, cancellationRequested: !item.cancellationRequested }
              : item
          ) as OrderItem[],
        } as PaginatedItems<OrderItem>,
      } as InitialState;

    default:
      return state;
  }
};
